import React from 'react';
import {Link } from "react-router-dom";
import Actions from '../../helpers/actions';
import Functions from '../../helpers/functions';
import Locale from '../../assets/languages/locale.json';

import TipBox from '../../components/tipBox';

import {FormattedMessage,FormattedNumber,FormattedDate,FormattedTime,FormattedRelativeTime} from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faLifeRing, faChevronRight,faEnvelope,faExclamationTriangle} from '@fortawesome/pro-regular-svg-icons'
import { StickyContainer, Sticky } from 'react-sticky';
import { Line, Circle } from 'rc-progress';
import Avatar from 'react-avatar';

import Select from 'react-select';
import Swiper from 'react-id-swiper';

import Highcharts from 'highcharts';
import {
    HighchartsChart, Chart, withHighcharts, XAxis, YAxis, Tooltip, Title, Subtitle, Legend, LineSeries, SplineSeries
} from 'react-jsx-highcharts';
import {Formik} from "formik";

class DashBoard extends React.Component {
    constructor(props) {
        super(props);
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var data1 = [];
        var data2 = [];

        var date1 = new Date(y, m, 0);
        var date2 = new Date(y, m - 1, 0);

        for(var i =0;i<7;i++){
            date1.setDate(date1.getDate() + 1);
            data1.push([Functions.getFormattedDate(date1,"DD MMM YYYY"), (Math.floor(Math.random() * 20) + 1 )]);

            date2.setDate(date2.getDate() + 1);
            data2.push([Functions.getFormattedDate(date2,"DD MMM YYYY"), (Math.floor(Math.random() * 20) + 1 )]);
        }

        this.state = {
            data1:data1,
            data2:data2,
            view:Actions.getView()
        };

        var chartOptions = {
            alignTicks: false,
            dateTime:Locale.tr.dateTime,
            yAxis:{
                endOnTick: false,
                maxPadding: 0
            },
            xAxis: {
                categories: this.state.data1,
                labels:{
                    formatter: function() {
                        date = Functions.getFormattedDate(this.value,"DD / MM");
                        return date;
                    }
                }
            }
        }

        Highcharts.setOptions(chartOptions);
        Actions.register("viewSwitch",this.viewSwitch.bind(this));
    }
    viewSwitch(view){
        this.setState({view:view});
    }
    renderView(){
        switch(this.state.view){
            case 1:
                return(
                    <div className={"row"}>
                        <div className={"columns small-12 medium-4"}>
                            <div className={"stickyWrapper"}>
                                <StickyContainer>
                                    <div className="activity">
                                        <Sticky bottomOffeset={100}>

                                            {({
                                                  style,
                                              }) => (
                                                <div className={"row collapse"}>
                                                    <div style={style} className={"columns small-12"}>
                                                        <div className={"block"}>
                                                            <div>
                                                                <b>Offers & Orders</b>
                                                                <a href="#a" className="action link">Show all <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                                                <div className={"container"}>
                                                                    <div className={"line"}></div>
                                                                    <ul className={"streaming"}>
                                                                        {this.renderActivities([
                                                                            {type:0,fullName:"Ahmet Çetin",title:"Yeni bir uyumsuzluk oluşturdu",message:"British Petrol isimli firmaya LPG Trailer teklifi gönderildi."},
                                                                            {type:0,fullName:"Selim Çalışkan",title:"Yeni bir uyumsuzluk oluşturdu",message:"British Petrol isimli firmaya LPG Trailer teklifi gönderildi."},
                                                                            {type:0,fullName:"Fatih Karaca",title:"Yeni bir uyumsuzluk oluşturdu",message:"British Petrol isimli firmaya LPG Trailer teklifi gönderildi."},
                                                                            {type:0,fullName:"Fatih Karaca",title:"Yeni bir uyumsuzluk oluşturdu",message:"British Petrol isimli firmaya LPG Trailer teklifi gönderildi."},
                                                                            {type:0,fullName:"Fatih Karaca",title:"Yeni bir uyumsuzluk oluşturdu",message:"British Petrol isimli firmaya LPG Trailer teklifi gönderildi."},
                                                                            {type:0,fullName:"Fatih Karaca",title:"Yeni bir uyumsuzluk oluşturdu",message:"British Petrol isimli firmaya LPG Trailer teklifi gönderildi."},
                                                                        ])}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Sticky>
                                    </div>
                                </StickyContainer>
                            </div>
                        </div>
                        <div className={"columns small-12 medium-4"}>
                            <div className={"stickyWrapper"}>
                                <StickyContainer>
                                    <div className="activity">
                                        <Sticky bottomOffeset={100}>

                                            {({
                                                  style,
                                              }) => (
                                                <div className={"row collapse"}>
                                                    <div style={style} className={"columns small-12"}>
                                                        <div className={"block"}>
                                                            <div>
                                                                <b>Uygunsuzluklar</b>
                                                                <a href="#a" className="action link">Show all <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                                                <div className={"container"}>
                                                                    <div className={"line"}></div>
                                                                    <ul className={"streaming"}>
                                                                        {this.renderActivities([
                                                                            {type:0,fullName:"Ahmet Çetin",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                            {type:0,fullName:"Selim Çalışkan",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                            {type:0,fullName:"Fatih Karaca",title:"Uyumsuzluğu giderdi",message:"XCA1 kodlu ürün kaynak kısmı hatası giderildi."},
                                                                            {type:0,fullName:"Selim Karaca",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                            {type:0,fullName:"Farabi Gezgin",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                            {type:0,fullName:"Ali Koca",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                        ])}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Sticky>
                                    </div>
                                </StickyContainer>
                            </div>
                        </div>
                        <div className={"columns small-12 medium-4"}>
                            <div className={"columns small-12 block"}>
                                <div className="list">
                                    <div className={"header row"}>
                                        <div className={"columns small-12"}>
                                            <b>Projects Status</b>
                                            <a href="#a" className="action link">Show all <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                        </div>
                                        <div className={"columns"}>

                                        </div>
                                    </div>
                                    <div className={"container"}>
                                        <ul className={"streaming"}>
                                            {this.renderProjects()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return(
                    <div className={"row"}>
                        <div className={"columns small-6"}>
                            <div className={"columns small-12 block fixed"}>
                                <div className={"row"}>
                                    <div className={"columns small-12 medium-6"}>
                                        <div className="recent">
                                            <b>Son aktif kullanıcılar</b>
                                            <ul className="faces row">
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                                <li className="columns shrink">
                                                    <div className="visitor">
                                                        <img className="transition" src={Functions.fakeProfileImage()}/>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div className="text">
                                                <a href="#a" className="action link">Show all <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"columns small-12 medium-6"}>
                                        <div className={"graph"}>
                                            <Swiper pagination={{
                                                el: '.swiper-pagination',
                                                type: 'bullets',
                                                clickable: true
                                            }} autoplay={true}>
                                                <div>
                                                    <b>Performans</b>
                                                    <div >
                                                        <HighchartsChart plotOptions={{
                                                        }} >
                                                            <Chart height={100} backgroundColor={"transparent"} margin={20} marginBottom={10} marginLeft={32}/>
                                                            <XAxis tickInterval={4}>
                                                                <XAxis.Title>Time</XAxis.Title>
                                                            </XAxis>

                                                            <Tooltip valueSuffix=" kullanıcı" />
                                                            <YAxis tickInterval={3}>
                                                                <SplineSeries name="İşlem" data={this.state.data1} />
                                                                <SplineSeries name="Uygunsuzluk raporu" data={this.state.data2} />
                                                            </YAxis>
                                                        </HighchartsChart>
                                                    </div>
                                                </div>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"columns small-6"}>
                            <div className={"columns small-12 block fixed"}>
                                <div className={"row"}>
                                    <div className={"columns small-12 medium-6"}>
                                        <div className="progress">
                                            <b>Tamamlanan Projeler</b>
                                            <p>Tüm projelerden süreci başarıyla tamamlayan projeler</p>
                                            <div className={"wrapper"}>
                                                <div className={"count"}>78<small>%88</small></div>
                                                <Line percent="88" strokeWidth="4" strokeColor="#7bb5ec" trailWidth={4} trailColor="#e6e6e6"/>
                                            </div>
                                            <div className="text">
                                                <a href="#a" className="action link">Listele <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"columns small-12 medium-6"}>
                                        <div className="progress">
                                            <b>Duraklayan Projeler</b>
                                            <p>Tüm projelerden süreç içerisindeduraksayan projeler</p>
                                            <div className={"wrapper"}>
                                                <div className={"count"}>12<small>%38</small></div>
                                                <Line percent="38" strokeWidth="4" strokeColor="#7bb5ec" trailWidth={4} trailColor="#e6e6e6"/>
                                            </div>
                                            <div className="text">
                                                <a href="#a" className="action link">Listele <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"columns small-12 medium-8"}>
                            <div className={"columns small-12 block"}>
                                <div className="list">
                                    <div className={"header row"}>
                                        <div className={"columns shrink"}>
                                            <div className={"title"}><b>Proje</b></div>
                                        </div>
                                        <div className={"columns small-2"}>
                                            <b>Yetkililer</b>
                                        </div>
                                        <div className={"columns small-5"}>
                                            <b>Durum</b>
                                        </div>
                                        <div className={"columns"}>

                                        </div>
                                    </div>
                                    <div className={"container"}>
                                        <ul>
                                            {this.renderUserList()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"columns small-12 medium-4"}>
                            <div className={"stickyWrapper"}>
                                <StickyContainer>
                                    <div className="activity">
                                        <Sticky bottomOffeset={100}>

                                            {({
                                                  style,
                                              }) => (
                                                <div className={"row collapse"}>
                                                    <div style={style} className={"columns small-12"}>
                                                        <div className={"info box"}>
                                                            <Swiper autoplay={true} direction={"vertical"}>
                                                                <div className={"row collapse"}>
                                                                    <div className={"columns shrink"}>
                                                                        <FontAwesomeIcon icon={faExclamationTriangle} size="lg"/>
                                                                    </div>
                                                                    <div className={"columns"}>
                                                                        <p>
                                                                            Ekim 2020'a göre proje süreçleri 18% daha yavaş ilerliyor
                                                                        </p>
                                                                    </div>
                                                                    <div className={"columns shrink more"}>
                                                                        <FontAwesomeIcon icon={faChevronRight} size="lg"/>
                                                                    </div>
                                                                </div>
                                                                <div className={"row collapse"}>
                                                                    <div className={"columns shrink"}>
                                                                        <FontAwesomeIcon icon={faExclamationTriangle} size="lg"/>
                                                                    </div>
                                                                    <div className={"columns"}>
                                                                        <p>
                                                                            Toplam 4 proje 7 günü geçmesine rağmen duraksaması devam ediyor.
                                                                        </p>
                                                                    </div>
                                                                    <div className={"columns shrink more"}>
                                                                        <FontAwesomeIcon icon={faChevronRight} size="lg"/>
                                                                    </div>
                                                                </div>
                                                            </Swiper>
                                                        </div>
                                                        <div className={"block"}>
                                                            <div>
                                                                <b>Son haraketler</b>
                                                                <a href="#a" className="action link">Show all <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                                                <div className={"container"}>
                                                                    <div className={"line"}></div>
                                                                    <ul className={"streaming"}>
                                                                        {
                                                                            this.renderActivities([
                                                                                {type:0,fullName:"Ahmet Çetin",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                                {type:0,fullName:"Selim Çalışkan",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."},
                                                                                {type:0,fullName:"Fatih Karaca",title:"Yeni bir uyumsuzluk oluşturdu",message:"Kullanılması planlanan XCA1 kodlu ürün kaynak kısmı hatalı olduğu tespit edildi."}
                                                                            ])
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Sticky>
                                    </div>
                                </StickyContainer>
                            </div>
                        </div>
                    </div>
                );
                break;
        }
    }
    render(){
        return (
            <div id={"dashboard"}>
                <div className={"row"}>
                    <div className={"columns small-12"}>
                        <div className={"columns small-12 block noPad"}>
                            <div className={"announcements"}>
                                <Swiper autoplay={true} direction={"vertical"}>
                                    <div>
                                        <FontAwesomeIcon icon={faLifeRing} size="lg"/> <b>Duyuru</b>: Sistem kullanımı yaparken bir sorun ile karşılaşırsanız bize bildirin.<span
                                        className="sperate">|</span><a href="#x" className="feedback" data-type="0">Geri
                                        bildirim için tıklayın</a>
                                    </div>
                                    <div>
                                        <FontAwesomeIcon icon={faLifeRing} size="lg"/> <b>Duyuru</b>: Sistem kullanımı yaparken bir sorun ile karşılaşırsanız bize bildirin.<span
                                        className="sperate">|</span><a href="#x" className="feedback" data-type="0">Geri
                                        bildirim için tıklayın</a>
                                    </div>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className={"columns small-12"}>
                        {this.renderView()}
                    </div>
                </div>
            </div>
        );
    }
    renderUserList(){
        var data = [{},{},{},{},{},{}];
        return data.map((data,key)=>{
            return(
                <li className={"row user"} key={"u_"+key}>
                    <div className={"columns name shrink"}>
                        <div className={"title"}>
                            <div className={"row collapse"}>
                                <div className={"columns"}>
                                    <a onClick={()=>{
                                        this.props.openSidePanel("project",3)
                                    }}><b>British Petrol</b></a>
                                    <small>LPG - DY 2334 1235</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"columns small-2"}>
                        <ul className="faces row">
                            <li className="columns shrink">
                                <div className="visitor">
                                    <img className="transition" src={Functions.fakeProfileImage()}/>
                                </div>
                            </li>
                            <li className="columns shrink">
                                <div className="visitor">
                                    <img className="transition" src={Functions.fakeProfileImage()}/>
                                </div>
                            </li>
                            <li className="columns shrink">
                                <div className="visitor">
                                    <img className="transition" src={Functions.fakeProfileImage()}/>
                                </div>
                            </li>
                            <li className="columns shrink">
                                <div className="visitor">
                                    <img className="transition" src={Functions.fakeProfileImage()}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={"columns small-4 name"}>
                        <b>Teklif onaylandı ve iş emrine dönüştürüldü</b>
                        <small><FormattedRelativeTime value={((new Date().getTime() - (60*3)) - new Date().getTime())} numeric="auto" updateIntervalInSeconds={10} /></small>
                    </div>
                    <div className={"columns"}>
                        <div className={"row align-right"}>
                            <div className={"columns shrink"}>
                                <Link to={"google"} className={"button small"}>Görüntüle</Link>
                            </div>
                        </div>
                    </div>
                </li>
            );
        });
    }
    renderActivities(data){
        var icons = [faEnvelope];
        return data.map((data,key)=>{
            return(
                <li className={"row collapse"} key={"a_"+key}>
                    <div className={"columns shrink"}>
                        <img className={"image"} src="http://app.botonom.com/assets/img/visitors/1330.jpg"/>
                    </div>
                    <div className={"columns icon shrink"}>
                        <FontAwesomeIcon icon={icons[data.type]} size="1x"/>
                    </div>
                    <div className={"columns"}>
                        <div className={"detail"}>
                            <div className={"fullName"}>{data.fullName}</div>
                            <div className={"date"}>
                                <FormattedDate
                                    value={new Date()}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                />
                            </div>
                            <div className={"description"}>
                                <b>{data.title}</b><br/>
                                {data.message}

                            </div>
                        </div>
                    </div>
                </li>
            );
        });
    }
    renderProjects(){
        var data = [{},{},{},{},{},{}];
        return data.map((data,key)=>{
            return(
                <li className={"row user"} key={"u_"+key}>
                    <div className={"columns name small-12"}>
                        <div className={"title"}>
                            <div className={"row collapse"}>
                                <div className={"columns shrink"}>
                                    <Avatar color={"#5598d6"} name="L P G" src={"/assets/images/exampleCustomer.png"} size={35} round={true}/>
                                </div>
                                <div className={"columns"}>
                                    <a onClick={()=>{
                                        Actions.emit("closeSidePanel",{test:true});
                                    }}><b>British Petrol</b></a>
                                    <small>LPG - DY 2334 1235</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"columns small-12 name"}>
                        <div className={"row"}>
                            <div className={"columns small-12"}>
                                <div className="progress">
                                    <div className={"wrapper"}>
                                        <div className={"count"}><small className={"percent"}>%88</small></div>
                                        <Line percent="88" strokeWidth="2" strokeColor="#7bb5ec" trailWidth={2} trailColor="#e6e6e6"/>
                                    </div>
                                </div>
                            </div>
                            <div className={"columns small-12"}>
                                <b>Kesim büküm aşamasındadır</b>
                                <small>Last update: <FormattedRelativeTime value={((new Date().getTime() - (60*3)) - new Date().getTime())} numeric="auto" updateIntervalInSeconds={10} /></small>
                            </div>
                            <div className={"columns small-12"}>
                                <a  onClick={()=>{
                                    Actions.emit("openProject",{test:true});
                                }} className={"button small"}>Görüntüle</a>
                            </div>
                        </div>
                    </div>
                </li>
            );
        });
    }
}
export default withHighcharts(DashBoard, Highcharts);
